function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("title", null, "202013_VF_Icon_turn the device horizontal"), /*#__PURE__*/React.createElement("circle", {
  cx: "56.7",
  cy: "116.9",
  r: "10.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M84.9 28.5v113.1H28.5V28.5h56.4M99.2 0h-85C6.3 0 0 6.3 0 14.2v141.7c0 7.8 6.3 14.2 14.2 14.2h85c7.8 0 14.2-6.3 14.2-14.2V14.2C113.4 6.3 107 0 99.2 0z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "166.5",
  cy: "226.8",
  r: "10.6"
}), /*#__PURE__*/React.createElement("path", {
  d: "M255 198.6V255H141.9v-56.4H255m14.3-28.5H127.6c-7.8 0-14.2 6.3-14.2 14.2v85c0 7.8 6.3 14.2 14.2 14.2h141.7c7.8 0 14.2-6.3 14.2-14.2v-85c0-7.8-6.4-14.2-14.2-14.2zM229.4 100.8l-23.9 19.1V99.2c0-27.4-22.2-49.6-49.6-49.6h-14.2v14.2h14.2c19.6 0 35.4 15.9 35.4 35.4v20.7l-23.9-19.1-8.9 11.1 39.9 31.9 39.9-31.9-8.9-11.1z"
})));